"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLTIP_ID = void 0;
const TOOLTIP_ID = exports.TOOLTIP_ID = {
  DEFAULT: 'Click here for more information'
};